// extracted by mini-css-extract-plugin
export var legendIndicator = "_cf-1";
export var legendRight = "_cf-0";